export * from './cognitive'
export * from './auditive-and-ocular'
export * from './nutritional'
export * from './physical-activity'
export * from './social'
export * from './executive-summary'
export * from './general-recommendations'
export * from './tobacco-and-alcohol'
